import { mergeProps as _mergeProps, createVNode as _createVNode } from "vue";
import { useComponentModal } from '@/share/components';
import MgEditorForm from './mg-editor-form';
import { defineComponent, reactive, watch } from 'vue';

/**
 * createEditorForm 创建编辑器表单
 * @param config
 * @returns {(function(): *)|DefineComponent<IsKeyValues<unknown> extends true ? unknown : {}, function(): *, {}, {}, {}, ComponentOptionsMixin, ComponentOptionsMixin, TypeEmitsToOptions<{}>, string, PublicProps, ToResolvedProps<IsKeyValues<unknown> extends true ? unknown : {}, TypeEmitsToOptions<{}>>, ExtractDefaultPropTypes<ComponentObjectPropsOptions>, {}, {}, {}, string, ComponentProvideOptions, true, {}, any>}
 */
export const createEditorForm = (config = {
  save: '',
  query: '',
  queryParams: undefined,
  // 查询附带参数, (id)=> {}||{}
  afterQuery: undefined,
  // ({ params, data }) => data, // 查询后的数据处理函数
  beforeSave: undefined,
  // ({data}) => data||false // 编辑前,返回false,取消保存
  afterSave: undefined,
  // ({data, result}) => result, 保存后数据返回处理
  items: [],
  rules: {},
  data: {}
}) => {
  return defineComponent({
    setup(props) {
      const state = reactive({
        save: '',
        query: '',
        queryParams: undefined,
        // 查询附带参数, (id)=> {}||{}
        afterQuery: undefined,
        // ({ params, data }) => data, // 查询后的数据处理函数
        beforeSave: undefined,
        // ({data}) => data||false // 编辑前,返回false,取消保存
        afterSave: undefined,
        // ({data, result}) => result, 保存后数据返回处理
        items: [],
        rules: {},
        data: {}
      });
      watch(() => config, val => {
        Object.assign(state, toRaw(unref(val)));
      }, {
        immediate: true,
        deep: true
      });
      return () => {
        const {
          save: saveApi,
          query: queryApi,
          queryParams,
          afterQuery,
          beforeSave,
          afterSave,
          items,
          rules,
          data
        } = state;
        return _createVNode(MgEditorForm, _mergeProps(props, {
          queryApi: queryApi,
          saveApi: saveApi,
          queryParams: queryParams,
          afterQuery: afterQuery,
          beforeSave: beforeSave,
          afterSave: afterSave,
          items: items,
          rules: rules,
          data: data
        }), null);
      };
    }
  });
};
export const useEditorModal = props => {
  const editConfig = reactive({
    save: '',
    query: '',
    queryParams: undefined,
    // 查询附带参数, (id)=> {}||{}
    afterQuery: undefined,
    // ({ params, data }) => data, // 查询后的数据处理函数
    beforeSave: undefined,
    // ({data}) => data||false // 编辑前,返回false,取消保存
    afterSave: undefined,
    // ({data, result}) => result, 保存后// 返回false取消刷新
    items: [],
    rules: {},
    data: {},
    ...props.editConfig
  });
  watch(() => props.editConfig, val => {
    Object.assign(editConfig, val);
  }, {
    immediate: true,
    deep: true
  });
  const {
    openEditor
  } = useComponentModal();
  const EditorForm = createEditorForm(editConfig);
  return async (title, params, options = {
    id: '',
    // 转入id值将保持组件状态
    mask: true,
    maskClosable: true,
    width: '60%',
    escClosable: true,
    showZoom: true,
    resize: false,
    showMaximize: true,
    showClose: true,
    showFooter: true,
    lockView: true,
    showConfirmButton: true,
    showCancelButton: true,
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    confirmClosable: true,
    cancelClosable: true,
    footButtons: []
  }) => {
    const res = await openEditor(title, EditorForm, {
      ...params
    }, {
      ...options
    });
    return Promise.resolve(res);
  };
};